import { ReportItem } from "./types";

import { httpClient } from "@/http";

export const ReportService = {
  /** 代付日報表 */
  dailyReportWithdraw() {
    return httpClient<HttpResponse<{ items: ReportItem[] }>>().get(
      "/api/v1/user/me/report/daily-withdraw"
    );
  },
};
